import { useTranslations } from 'next-intl';
import { useTimeMachine } from '../context/time-machine-context';
import { useFilterSabaString } from '@/hooks/query/use-saba-filter';

type SliderProps = {
	isOpen: boolean;
	setIsOpen: (isOpen : boolean) => void;
}


export const TimeMachineSlider = ({
	setIsOpen,
	isOpen,
}: SliderProps) => {
	const { pointValue, setPointValue, currentTimeValue, is2HTemp } = useTimeMachine();
	const lastpointValue: number = 90;
	const isMaxValue = lastpointValue == pointValue;
	const isMinValue = currentTimeValue == pointValue;
	const { filterSabaString } = useFilterSabaString();
	const t = useTranslations('General');
	const tmHeaderName=filterSabaString(t('lbl_SABATM'));
	const handleHeaderOpen = async () => {
		if (!isOpen) {
			setIsOpen(true);
		}
	}
	const handleSlideChange = (event: any) => {
		const value = event.target.value;
		setPointValue(value);
		handleHeaderOpen();
	};
	const getWidthCss = () => {
		return ' calc' + `( ( 100 - ( ${currentTimeValue - (is2HTemp ? 45 : 0)} ) * ( ${is2HTemp ? 20 : 10}/9 ) ) * 1% )`;
	}
	const rangeValue = lastpointValue - currentTimeValue;
	const timePoint = (Number(pointValue) - Number(currentTimeValue))
	const timeBarStyleObj = {
		backgroundImage: '-webkit-linear-gradient(left ,rgb(255,170,0) 0%,rgb(255,0,0) ' 
				+ (timePoint * (100 / rangeValue)) + '%,rgb(93,0,255) ' 
				+ (timePoint * (100 / rangeValue)) + '%, rgb(255,0,0) 100%)'
	}
	
	return (
		<div className="tm-slider-group">
			<a className="tm-btn" data-disabled={isMinValue} onClick={() => {
				setPointValue((Number(pointValue) - 1)); 
				handleHeaderOpen();
			} }
			>
				<i className="tm-icon tm-icon--lessen"></i>
			</a>


			<div className="tm-slider">
				<span className="tm-text-title">{tmHeaderName}</span>
				<div className="tm-slider__bg"></div>
				<div className="tm-slider__bar" style={{ width: getWidthCss() }}>
					<div className="tm-slider__match-time">{currentTimeValue}&apos;</div>
					<input
						className="tm-slider__range"
						type="range"
						min={currentTimeValue}
						max={lastpointValue}
						id="time-bar"
						value={pointValue}
						onChange={handleSlideChange}
						step="1"
						style={timeBarStyleObj}
					>
					</input>
				</div>
				<div className="tm-slider__info">
					<div className="tm-slider__tag-start"></div>
					<div className="tm-slider__tag-ht"></div>
					<div className="tm-slider__tag-ft"></div>
				</div>
			</div>


			<a className="tm-btn" data-disabled={isMaxValue} onClick={() => {
				setPointValue((Number(pointValue) + 1)); 
				handleHeaderOpen();
			}}
			>
				<i className="tm-icon tm-icon--addition"></i>
			</a>

		</div>
	)
}
